import React from 'react';

export class Address extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const isUK = this.props.isUK;
        const isPerson = this.props.isPerson;
        if (isUK){
            return (
                <div className="address">
                        <p>{this.props.street}</p>
                        <p>{this.props.town} </p>
                        <p>{this.props.city} </p>
                        <p>{this.props.county} </p>
                        <p>{this.props.zipcode} </p>
                        <p>{this.props.country} </p>
                    </div>
                );
        }
        else if (isPerson) {
            return (
                <div className="address">
                    <p>{this.props.street}</p>
                    <p>{this.props.zipcode} {this.props.city}</p>
                    <p>{this.props.county}</p>
                </div>  
                );
        }
        else {
            return (
                <div className="address">
                     <p>{this.props.street}</p>
                     <p>{this.props.zipcode}</p>
                     <p>{this.props.city}</p>
                     <p>{this.props.country}</p>
                </div>
                );
        }        
    }
}